<template>
    <transition name="modal">
        <div class="modal-mask" @click.self="$emit('close')">
            <div class="modal-wrapper" @click.self="$emit('close')">
                <div class="modal-container">

                <div class="modal-header">
                    <slot name="header">
                    default header
                    </slot>
                </div>

                <div class="modal-body">
                    <slot name="body">
                    default body
                    </slot>
                </div>

                <div class="modal-footer">
                    <button class="close" @click="$emit('close')">
                        Cerrar
                    </button>
                </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
  name: 'modal'
}
</script>
<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 105vh;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  padding: .4em;
}

.modal-container {
  max-height: 80vh;
  max-width: 90vw;
  width: 60%;
  min-width: 200px;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 1em;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  opacity: 0.95;
  margin: 0 auto;
  overflow: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 1em 0;
}
.modal-footer {
    text-align: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.close {
  font-weight: bold;
  font-size: 1.4em;
  color:  #570c7a;
  background: transparent;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  /* background: linear-gradient(to right, #30CFD0 10%, #570c7a 90%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; */
  outline: none;
  border: none;
  padding: 0;
}
.close, span {
 display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue